/**
 * Stable UUIDs inserted by order-system src/api/database/mockdev/mock_data.sql (SECTION B).
 * Keep in sync with that file and order_confirmation_settings seed row.
 */
export const MOCK_SEED_IDS = {
  organization: {
    id: 'f0000001-0000-4000-8000-000000000001',
    tenantId: '88fa37a1-30f4-4462-b24e-b87207dad8e1',
    name: 'FrontFlow',
  },
  workflow: 'a0000001-0000-4000-8000-000000000001',
  orderConfirmationSettings: 'b0000001-0000-4000-8000-000000000001',
  purchaseOrders: {
    po1: 'c0000001-0000-4000-8000-000000000001',
    po2: 'c0000002-0000-4000-8000-000000000002',
    po3: 'c0000003-0000-4000-8000-000000000003',
    /** Partial delivery: OC splits PO row 001.00 into 001.00-A and 001.00-B */
    po6: 'c0000006-0000-4000-8000-000000000006',
  },
  orderConfirmations: {
    po1Oc1: 'd0000001-0000-4000-8000-000000000001',
    po2Oc1: 'd0000002-0000-4000-8000-000000000002',
  },
  emails: {
    po1Oc1: 'e0000001-0000-4000-8000-000000000001',
    po2Oc1: 'e0000002-0000-4000-8000-000000000002',
  },
} as const
